import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

const INITIAL_STATE = false;

const resetIsFsEmbedVar = () => {
  isFsEmbedVar(INITIAL_STATE);
};

const isFsEmbedVar: ReactiveVar<boolean> = makeFSVar(
  INITIAL_STATE,
  "useIsFsEmbedVar",
  resetIsFsEmbedVar
);

const setIsFsEmbedVar = (newVal: boolean) => {
  isFsEmbedVar(newVal);
};

const useIsFsEmbedVar = (): boolean => {
  return useReactiveVar(isFsEmbedVar);
};

export { useIsFsEmbedVar, setIsFsEmbedVar, isFsEmbedVar };
